import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuditComponent} from './audit.component';
import * as angular from 'angular';

/*
* Workaround para que siga funcionando la configuración
* $routeProvider.otherwise() que redirige a la pantalla de error
* cuando se ingresan URLs desconocidas.
* */
angular.module('CarsSaraBo')
    .config(['$routeProvider', ($routeProvider) => {
        $routeProvider.when('/audit-a2', {template: ''});
    }]);
/***/

const auditRoutes: Routes = [
    {path: 'audit-a2', component: AuditComponent},
    {path: 'cars-sara-v2/web/audit-a2', component: AuditComponent}
];

@NgModule({
    imports: [
        RouterModule.forChild(auditRoutes)
    ],
    exports: [
        RouterModule
    ]
})
export class AuditRoutingModule {
}



// WEBPACK FOOTER //
// ./public/upgrade/feature/audit/audit-routing.module.ts